<template>
  <Dialog
    title="克隆课程"
    :visible.sync="dialogVisible"
    width="520px"
    :close-on-click-modal="false"
    :before-close="cancel"
  >
    <el-form ref="formRef" :model="form" :rules="rules" label-width="110px">
      <el-form-item label="源课程">
        <span class="clone-source">{{ sourceName || "-" }}</span>
      </el-form-item>
      <el-form-item label="新课程名称" prop="courseName">
        <el-input
          v-model.trim="form.courseName"
          maxlength="100"
          show-word-limit
          placeholder="请输入新课程名称"
          @keyup.enter.native="submitForm"
        />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button plain round size="small" @click="cancel">取 消</el-button>
      <el-button
        plain
        round
        size="small"
        type="primary"
        :loading="submitLoading"
        @click="submitForm"
        >确认克隆</el-button
      >
    </div>
  </Dialog>
</template>

<script>
import { cloneCourse } from "@/api/course";

export default {
  name: "CourseCloneDialog",
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      sourceCode: "",
      sourceName: "",
      form: {
        courseName: ""
      },
      rules: {
        courseName: [
          { required: true, message: "请输入新课程名称", trigger: "blur" },
          {
            min: 1,
            max: 100,
            message: "课程名称长度需在 1~100 个字符",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    open(row = {}) {
      this.sourceCode = row.courseCode || "";
      this.sourceName = row.courseName || "";
      this.form.courseName = row.courseName
        ? `${row.courseName}-副本`
        : "";
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate();
      });
    },
    cancel(done) {
      this.dialogVisible = false;
      this.sourceCode = "";
      this.sourceName = "";
      this.form.courseName = "";
      this.submitLoading = false;
      if (typeof done === "function") done();
    },
    async submitForm() {
      if (this.submitLoading) return;
      if (!this.sourceCode) {
        this.$message.warning("源课程编码缺失");
        return;
      }
      try {
        await this.$refs.formRef.validate();
      } catch (e) {
        return;
      }
      this.submitLoading = true;
      try {
        await cloneCourse(this.sourceCode, this.form.courseName);
        this.$message.success("克隆成功");
        this.cancel();
        this.$emit("success");
      } catch (e) {
      } finally {
        this.submitLoading = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.clone-source {
  color: #606266;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/views/Course/CourseCloneDialog.vue